import PropTypes from 'prop-types';
import React from 'react';
import Col from 'react-bootstrap/lib/Col';
import Row from 'react-bootstrap/lib/Row';
import _ from 'lodash';

import config from '../../config';
import t from '../../lib/I18n';
import SmartcardRegistration from '../../records/customer/SmartcardRegistration';
import User from '../../records/User';
import CustomerRegistration from '../../records/customer/Registration';

import PureRenderComponent from '../PureRenderComponent';
import SmartcardRegistrationForm from './SmartcardRegistrationForm';
import RegisterOptions from './RegisterOptions';
import FormWrapper from '../form/FormWrapper';

class RegisterSmartcard extends PureRenderComponent {

    static propTypes = {
        onChange: PropTypes.func.isRequired,
        smartcard: PropTypes.instanceOf(SmartcardRegistration).isRequired,
        user: PropTypes.oneOfType([
            PropTypes.instanceOf(User),
            PropTypes.instanceOf(CustomerRegistration)
        ]),
        badPostcode: PropTypes.string,
        forceSignup: PropTypes.bool,
        enableSmartcardTransferAtSignUp: PropTypes.bool,
        enableKeyGoRegistrationAtSignup: PropTypes.bool,
        onSelectAddress: PropTypes.func.isRequired,
        hideSmartcardCheckbox: PropTypes.bool,
        submitted: PropTypes.bool,
        showBenefits: PropTypes.bool,
        smartcardSubmitted: PropTypes.bool,
        hideSmartcardPromotionalText: PropTypes.bool,
        customPromotionalText: PropTypes.string,
        onAgeToggle: PropTypes.func,
    };

    static defaultProps = {
        badPostcode: '',
        forceSignup: false,
        enableSmartcardTransferAtSignUp: false,
        enableKeyGoRegistrationAtSignup: false,
        hideSmartcardCheckbox: false,
        showBenefits: false,
        submitted: false,
        smartcardSubmitted: false,
        hideSmartcardPromotionalText: false,
        onAgeToggle: _.noop,
    };

    render () {
        const { smartcard,
            onChange,
            forceSignup,
            enableSmartcardTransferAtSignUp,
            enableKeyGoRegistrationAtSignup,
            hideSmartcardCheckbox,
            showBenefits,
            submitted,
            hideSmartcardPromotionalText,
            customPromotionalText,
            user,
        } = this.props;

        return (
            <FormWrapper submitted={ submitted }>
                <Row>
                    <Col md={ 12 }>
                        {!hideSmartcardPromotionalText &&
                            <React.Fragment>
                                <a href={ config.get('smartcardReadMoreUrl') } target="_blank">
                                    <img
                                        src={config.get('registerSmartcardImageUrl')}
                                        alt={t('account.register.smartcard.alt')}
                                        className="smartcard-signup__image padding--horiz pull-right hidden-mobile"
                                    />
                                </a>
                                <div className="smartcard-signup smartcard-checkbox">
                                    <RegisterOptions
                                        onChange={ onChange }
                                        smartcard={ smartcard }
                                        forceSignup={ forceSignup }
                                        enableSmartcardTransferAtSignUp={ enableSmartcardTransferAtSignUp }
                                        enableKeyGoRegistrationAtSignup={ enableKeyGoRegistrationAtSignup }
                                        hideSmartcardCheckbox={ hideSmartcardCheckbox }
                                        customPromotionalText={ customPromotionalText }
                                        showBenefits={ showBenefits }
                                    />
                                </div>
                            </React.Fragment>
                        }
                        { (smartcard.withSmartcard() || !user.created) &&
                            <SmartcardRegistrationForm { ...this.props } /> }
                    </Col>
                </Row>
            </FormWrapper>
        );
    }
}


export default RegisterSmartcard;



// WEBPACK FOOTER //
// ./src/components/login/RegisterSmartcard.js